import { HTTP_CP_AdvisorUser } from '@api-new/userservice';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared/models/app-state.model';

export const getAdviserDetail = createAction('[ADVISER] Get Adviser Detail');

export const getAdviserDetailSuccess = createAction('[ADVISER] Get Adviser Detail Success', props<{ adviser: HTTP_CP_AdvisorUser }>());

export const getAdviserDetailFailure = createAction('[ADVISER] Get Adviser Detail Failure', props<{ error: ErrorModel }>());
